/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { pipelineStageShow } from '../../axios/pipelineStageShow'
import type {
	PipelineStageShowError,
	PipelineStageShowPathParams,
	PipelineStageShowResponse,
} from '../../types/PipelineStageShow'

export const pipelineStageShowQueryKey = (campaign: PipelineStageShowPathParams['campaign']) =>
	[{ url: '/campaigns/:campaign/pipeline-stages', params: { campaign } }] as const

export type PipelineStageShowQueryKey = ReturnType<typeof pipelineStageShowQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/PipelineStageController.php PipelineStageController::show */
export function pipelineStageShowQueryOptions(
	campaign: PipelineStageShowPathParams['campaign'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		PipelineStageShowResponse,
		AxiosError<PipelineStageShowError>,
		PipelineStageShowResponse,
		PipelineStageShowQueryKey
	>({
		queryKey: pipelineStageShowQueryKey(campaign),
		queryFn: ({ signal }) => pipelineStageShow(campaign, { signal, ...config }).then(res => res.data),
		enabled: !!campaign,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/PipelineStageController.php PipelineStageController::show */
export function usePipelineStageShow<TSelectData = PipelineStageShowResponse>(
	campaign: PipelineStageShowPathParams['campaign'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					PipelineStageShowResponse,
					AxiosError<PipelineStageShowError>,
					TSelectData,
					PipelineStageShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<PipelineStageShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...pipelineStageShowQueryOptions(campaign),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/PipelineStageController.php PipelineStageController::show */
export function usePipelineStageShowSuspense<TSelectData = PipelineStageShowResponse>(
	campaign: PipelineStageShowPathParams['campaign'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					PipelineStageShowResponse,
					AxiosError<PipelineStageShowError>,
					TSelectData,
					PipelineStageShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<PipelineStageShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...pipelineStageShowQueryOptions(campaign),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
